var map = {
	"./menu-job-active.png": 4828,
	"./menu-job.png": 264,
	"./menu-python-active.png": 6451,
	"./menu-python.png": 1539,
	"./menu-quantify-active.png": 5496,
	"./menu-quantify.png": 2725,
	"./menu-software-active.png": 2337,
	"./menu-software.png": 9370,
	"./menu-strategy-active.png": 7459,
	"./menu-strategy.png": 5287,
	"./menu-system-active.png": 3087,
	"./menu-system.png": 5799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6740;